import { isOutdated } from 'components/pages/accessreview/details/campaign_accuracy/ConnectorStatusAccuracyStatus'
import { differenceInDays } from 'date-fns'
import { ConnectorInstallationValue } from 'lib/actions/connector_catalog'
import { ConnectorSyncLifecycleStatus, FileConfig } from 'pbts/c1/api/app/v1/connector'
import { Any } from 'pbts/google/protobuf/any'
import { Timestamp as pbtsTimestamp } from 'pbts/google/protobuf/timestamp'

export enum ConnectorAccuracyStatus {
    ERROR = 0,
    WARNING = 1,
    UNDEFINED = 2,
    SUCCESS = 3,
}

export const getConnectorAccuracyStatus = (connector: ConnectorInstallationValue): ConnectorAccuracyStatus => {
    if (!connector || !connector.connectorSyncLifecycle || !connector.accessReviewConnectorSource) {
        return ConnectorAccuracyStatus.UNDEFINED
    }
    // Check if the connector is not connected or unspecified
    if (connector.connectorSyncLifecycle?.status === ConnectorSyncLifecycleStatus.SYNC_LIFECYCLE_STATUS_NOT_CONNECTED
        || (!connector.accessReviewConnectorSource?.syncEndAt
            && connector.connectorSyncLifecycle?.status === ConnectorSyncLifecycleStatus.SYNC_LIFECYCLE_STATUS_ERRORED)
    ) {
        return ConnectorAccuracyStatus.WARNING
    }
    // Check if the connector has errored
    if (connector.connectorSyncLifecycle?.status === ConnectorSyncLifecycleStatus.SYNC_LIFECYCLE_STATUS_ERRORED) {
        return ConnectorAccuracyStatus.ERROR
    }
    // Check if the connector's config or sync end timestamp is undefined
    if (!connector.configType || !connector.accessReviewConnectorSource?.syncEndAt) {
        return ConnectorAccuracyStatus.WARNING
    }

    // Determine if the connector is file-based
    const isFileBasedConnector = Any.typeUrlToName(connector.configType) === FileConfig.typeName

    // Calculate the number of days since the last sync
    const lastSyncDate = pbtsTimestamp.toDate(connector.accessReviewConnectorSource?.syncEndAt)
    const daysSinceLastSync = differenceInDays(new Date(), lastSyncDate)

    // Check if the connector is outdated
    const isOutdatedConnector = isOutdated(daysSinceLastSync, isFileBasedConnector)

    if (isOutdatedConnector) {
        return ConnectorAccuracyStatus.WARNING
    }

    return ConnectorAccuracyStatus.SUCCESS
}
